import { IOrderBy } from "../../../../Global/Base/DataSources/Interfaces";
import { registerCustomElement } from "../../../UI.ElementarControls/Utils/CustomElementUtils";
import { CompactDataGrid } from "../../CompactDatagrid";
import { DataGridSharedMethods } from "../../DataGridSharedMethods";
import { Column } from "../Columns/Column";
import { HeaderCell } from "./HeaderCell";
import { HeaderRow } from "./HeaderRow";
import { ICompactDataRowElement } from "./IDataRow";

export class CompactHeaderRow extends HeaderRow {
    //#region Events
    //#endregion Events

    //#region Listeners
    //#endregion Listeners

    //#region Fields
    //#endregion Fields

    //#region Properties
    public override get extraClasses(): string[] {
        return [];
    }
    //#endregion Properties

    //#region Constructors
    //#endregion Constructors

    //#region Methods
    public override render(owner: CompactDataGrid<ICompactDataRowElement>, _columns: Array<Column>, _OrderBy: IOrderBy[]): void {
        this._headerCells = [];
        this.renderOrderBy(owner);
    }

    public override renderOrderBy(owner: CompactDataGrid<ICompactDataRowElement>): void {
        this._owner = owner;
        if (!this._headerCells)
            this._headerCells = [];

        const els = this.querySelectorAll("tsc-headertemplate");
        for (const el of els) {
            this.removeChild(el);
        }

        for (let i = 0; i < owner.columns.length; i++) {
            const column: Column = owner.columns[i];
            const headerCell = new HeaderCell(owner, i, column);
            const indexOf = DataGridSharedMethods.orderByIndexOf(owner.orderBy, column.orderAttrName);

            if (indexOf > -1) {
                this.appendChild(headerCell.render(owner.orderBy[indexOf].order));
                this._headerCells.push(headerCell);
            }
        }
    }

    //#endregion Methods

    //#region HTMLElement
    protected override _constructor(): void {
        super._constructor();

        this.classList.add("compact");
    }

    //#endregion HTMLElement
}

registerCustomElement("tsc-CompactHeaderRow", CompactHeaderRow);
